export default {
  namespaced: true,
  state: {
    // The Work Experiences currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'updatedAt',
      descending: false
    }
  },
  getters: {
    find: state => id => state.active.find(experience => experience.id == id)
  },
  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'id', descending: true },
        filters = {}
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
    set(state, experience) {
      state.active = state.active.filter(o => o.id != experience.id)
      state.active.push(experience)
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    }
  },
  actions: {
    search(
      { commit, state },
      { search = '', page = 1, rowsPerPage = 25, sortBy = 'updated_at', descending = true, filters = {} }
    ) {
      this.$authorize('list', 'Experience')

      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters
      }

      state.loading = true
      return Vue.$http
        .get('admin/experiences', { params })
        .then(response => commit('setActive', response.data))
        .catch(error => (state.loading = false))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'Experience')

      return Vue.$http
        .get(`admin/experiences/${id}`)
        .then(response => commit('set', response.data))
    },
    create({ commit, dispatch }, experience) {
      this.$authorize('create', 'Experience')

      return Vue.$http
        .post('admin/experiences', { experience }).then(response => {
          commit('snackbar', { text: 'Work experience was created successfully', type: 'success' }, { root: true })
          dispatch('search', {
            filters: { profile: experience.profile.id },
            sortBy: 'endsAt',
            descending: true,
          })
        })
        .catch(error => {
          commit(
            'snackbar',
            { text: 'There was a problem creating the work experience', type: 'error' },
            { root: true }
          )
          return Object.assign(experience, error.response.data)
        })
    },
    update({ commit, dispatch }, experience) {
      this.$authorize('edit', 'Experience')

      return Vue.$http
        .patch(`admin/experiences/${experience.id}`, { experience })
        .then(({ data }) => {
          commit('snackbar', { text: 'Work experience was updated successfully', type: 'success' }, { root: true })
          commit('set', data)
          return data
        })
        .catch(error => {
          commit(
            'snackbar',
            { text: 'There was a problem updating the work experience', type: 'error' },
            { root: true }
          )
          return Object.assign(experience, error.response.data)
        })
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'Experience')

      return Vue.$http.delete(`admin/experiences/${id}`).then(
        response => {
          commit('remove', id)
          commit('snackbar', { text: 'You have removed this work experience', type: 'success' }, { root: true })
        }
      ).catch(() =>
      commit(
        'snackbar',
        { text: 'Unfortunately the work experience could not be removed', type: 'error' },
        { root: true }
      ))
    }
  }
}
